import React, { useEffect, useState, useRef } from "react";
import { CorreosIconStyles } from "./CorreosIconStyles";
import deleteIcon from "../../../assets/icons/ico_bin.svg";
import privacyIcon from "../../../assets/icons/ico_burofax.svg";
import documentIcon from "../../../assets/icons/ico_card.svg";
import emailIcon from "../../../assets/icons/ico_email.svg";
import linkIcon from "../../../assets/icons/ico_external_link.svg";
import addressIcon from "../../../assets/icons/ico_home.svg";
import servicesIcon from "../../../assets/icons/ico_legal.svg";
import lockIcon from "../../../assets/icons/ico_lock.svg";
import logOutIcon from "../../../assets/icons/ico_log_out.svg";
import moreIcon from "../../../assets/icons/ico_more_line.svg";
import phoneIcon from "../../../assets/icons/ico_phone.svg";
import statusIcon from "../../../assets/icons/ico_status.svg";
import appIcon from "../../../assets/icons/ico_app.svg";
import userIcon from "../../../assets/icons/ico_user.svg";
import enterprise from "../../../assets/icons/ico_enterprise.svg";
import cancel from "../../../assets/icons/ico_cancel_line.svg";
import city from "../../../assets/icons/ico_city.svg";
import world from "../../../assets/icons/ico_world.svg";
import mail from "../../../assets/icons/ico_mail.svg";
import verify from "../../../assets/icons/ico_verify.svg";
import pruebaMatri from "../../../assets/icons/ico_matricula.svg";
import editar from "../../../assets/icons/ico_edit.svg";
import addUser from "../../../assets/icons/ico_usuarios.svg";
import createAdm from "../../../assets/icons/ico_createAdm.svg";
import personal from "../../../assets/icons/ico_personal.svg";
import anadirIcon from "../../../assets/icons/ico_anadir.svg";

import { iconNames } from "../../../commons/EnumsGeneral";
import { checkIsNullUndefined } from "../../../commons/Utils";
import { CircularProgress } from "@material-ui/core";

export function CorreosIcon(props) {
    const classes = CorreosIconStyles();
    const { iconSelected, iconName, iconState, iconScale, padding } = props;
    const iconList = {
        [iconNames.delete]: deleteIcon,
        [iconNames.privacy]: privacyIcon,
        [iconNames.document]: documentIcon,
        [iconNames.email]: emailIcon,
        [iconNames.link]: linkIcon,
        [iconNames.address]: addressIcon,
        [iconNames.services]: servicesIcon,
        [iconNames.lock]: lockIcon,
        [iconNames.logOut]: logOutIcon,
        [iconNames.more]: moreIcon,
        [iconNames.phone]: phoneIcon,
        [iconNames.status]: statusIcon,
        [iconNames.app]: appIcon,
        [iconNames.user]: userIcon,
        [iconNames.enterprise]: enterprise,
        [iconNames.cancel]: cancel,
        [iconNames.city]: city,
        [iconNames.world]: world,
        [iconNames.mail]: mail,
        [iconNames.verify]: verify,
        [iconNames.pruebaMatri]: pruebaMatri,
        [iconNames.editar]: editar,
        [iconNames.addUser]: addUser,
        [iconNames.createAdm]: createAdm,
        [iconNames.personal]: personal,
        [iconNames.anadirIcon]: anadirIcon,
    };

    const [iconImage, setIconImage] = useState("");
    const [iconClass, setIconClass] = useState("");
    const [iconSize, setIconSize] = useState("");
    const [iconColor, setIconColor] = useState("#002E6D");
    const [svgContent, setSvgContent] = useState("");

    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        handleIconImage(iconSelected);
    }, [iconSelected]);

    useEffect(() => {
        handleIconClass(iconState);
    }, [iconState]);

    useEffect(() => {
        handleIconSize(iconScale);
    }, [iconScale]);

    useEffect(() => {
        if (!checkIsNullUndefined(iconImage) && !checkIsNullUndefined(iconColor) && !checkIsNullUndefined(iconSize)) {
            fetch(iconImage)
                .then(response => response.text())
                .then(data => {
                    if (isMounted.current) {
                        const svg = new DOMParser().parseFromString(data, "image/svg+xml");
                        const path = svg.querySelector(".icon-path");
                        if (path) {
                            path.setAttribute("fill", iconColor);
                        };
                        setSvgContent(new XMLSerializer().serializeToString(svg));
                    }
                });
        };
    }, [iconImage, iconColor, iconSize]);

    const handleIconImage = (auxIcon) => {
        let auxIconImage = iconList[auxIcon];
        setIconImage(auxIconImage);
    };

    const handleIconClass = (auxState) => {
        switch (auxState) {
            case "enabled":
                setIconClass(classes.enabled);
                setIconColor("#333333");
                break;
            case "disabled":
                setIconClass(classes.disabled);
                setIconColor("#CBCBCB");
                break;
            default:
                setIconClass(classes.basic);
                setIconColor("#002E6D");
                break;
        };
    };

    const handleIconSize = (auxScale) => {
        let auxSize = auxScale + "em";
        setIconSize(auxSize);
    };

    return (
        <>
            {checkIsNullUndefined(svgContent) ? <CircularProgress /> : (
                <img
                    src={`data:image/svg+xml;utf8,${encodeURIComponent(svgContent)}`}
                    alt={iconName}
                    className={iconClass}
                    style={{ width: iconSize, height: iconSize, margin: "auto 0em", padding: padding }}
                />
            )}
        </>

    );
}